









































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlAttachment from '@/components/common/control/CtrlAttachment.vue';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import { BUTTON } from '@/constants/label';
// PDF出力用
import {
  PageReport,
  FontDescriptor,
  FontStore,
} from '@grapecity/activereports/core';
import '../../../src/assets/scss/activeReportsJS/ar-js-ui.css';
import '../../../src/assets/scss/activeReportsJS/ar-js-viewer.css';
import { Viewer } from '@grapecity/activereports-vue';
import { PdfExport } from '@grapecity/activereports';

export default Vue.extend({
  name: 'PDFTest',
  props: {
    color: {
      type: String,
      default: 'primary',
    },
  },
  components: {
    JSViewer: Viewer,
    CtrlAttachment,
    CtrlNormalBtn,
  },
  data: () => ({
    BUTTON,
    fileData: {} as any,
    attachmentFlag: true,
    attachedData: null,
    attachmentTime: '',
  }),
  methods: {
    handleFileAttachment(data: any) {
      this.fileData = data;
    },
    async handleSave() {
      await axios({
        url: '/front_sample/post_file_pdf',
        data: this.fileData,
        method: 'POST',
      })
        .then(() => {
          alert('★' + 'Upload file OK');
        })
        .catch((error: any) => {
          console.log(error);
        });
    },
    // PDF作成&DL
    async uploadPDF() {
      // 帳票フォント定義
      const fonts: FontDescriptor[] = [
        { name: 'ＭＳ ゴシック', source: '/fonts/msgothic.ttc' ,postscriptName: 'MS-Gothic'},
        { name: 'IPAゴシック', source: '/fonts/ipag.ttf' },
      ];
      FontStore.registerFonts(...fonts);
      const report = new PageReport({ language: 'jp' });
      const doc = await report
        .load('/reports/N_Shu030_DeliveryReq.rdlx-json')
        .then(() => report.run());

      for (let i = 0; i < 5; i++) {
        PdfExport.exportDocument(doc, {
          info: {
            title: 'N_Shu030_DeliveryReq - PDF連続作成のサンプル',
          },
        })
          .then((result) => {
            // result.download('N_Shu030_DeliveryReq_PDF');

            // unique string
            const uniqueString = Math.random().toString(36).substr(2, 10);

            // Convert PDF to Base64
            const blob = result.data;
            let reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = async () => {
              const base64String = reader.result as string;
              console.log(typeof base64String);

              // send to BFF
              axios
                .post('/front_sample/pdftest', {
                  pdfBase64: base64String,
                })
                .then(function (response) {
                  console.log(response);
                })
                .catch(function (error) {
                  console.log(error);
                });

              // download PDF file with base64 string, no need to decode
              const downloadLink = document.createElement('a');
              downloadLink.href = base64String;
              downloadLink.download = uniqueString + '.pdf';
              downloadLink.click();
            };
          })
          .catch(console.error);
      }
    },
    // PDF作成&print
    async printPDF(paperSize: string) {
      const report = new PageReport({ language: 'jp' });
      await report
        .load(`/reports/${paperSize}.rdlx-json`)
        .then(() => report.run())
        .then((doc) => doc.print());
    },
    async downloadPDF(paperSize: string) {
      // 帳票フォント定義
      const fonts: FontDescriptor[] = [
        { name: 'ＭＳ ゴシック', source: '/fonts/msgothic.ttc' ,postscriptName: 'MS-Gothic'},
        { name: 'IPAゴシック', source: '/fonts/ipag.ttf' },
      ];
      FontStore.registerFonts(...fonts);
      const report = new PageReport({ language: 'jp' });
      const doc = await report
        .load(`/reports/${paperSize}.rdlx-json`)
        .then(() => report.run());
      //for (let i = 0; i < 5; i++) {
      PdfExport.exportDocument(doc, {
        info: {
          title: `${paperSize}`,
        },
      })
        .then((result) => {
          // unique string
          const uniqueString = Math.random().toString(36).substr(2, 10);

          // Convert PDF to Base64
          const blob = result.data;
          let reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = async () => {
            const base64String = reader.result as string;
            console.log(typeof base64String);

            // send to BFF
            axios
              .post('/front_sample/pdftest', {
                pdfBase64: base64String,
              })
              .then(function (response) {
                console.log(response);
              })
              .catch(function (error) {
                console.log(error);
              });

            // download PDF file with base64 string, no need to decode
            const downloadLink = document.createElement('a');
            downloadLink.href = base64String;
            downloadLink.download = uniqueString + '.pdf';
            downloadLink.click();
          };
        })
        .catch(console.error);
      //}
    },
    async exportOrder() {
      const res = await axios.get('/N_010juc/N_Juc040_JuchuListOut');
      const data = res.data;
      const reportResponse = await fetch(
        '/reports/N_Juc040_JuchuListOut.rdlx-json'
      );
      const report = await reportResponse.json();

      report.DataSources[0].ConnectionProperties.ConnectString =
        'jsondata=' + JSON.stringify(data);
      if (this.$refs.reportViewer) {
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.reportViewer.Viewer().open(report);
        // 帳票フォント定義
        const fonts: FontDescriptor[] = [
          { name: 'ＭＳ ゴシック', source: '/fonts/msgothic.ttc' ,postscriptName: 'MS-Gothic'},
          { name: 'IPAゴシック', source: '/fonts/ipag.ttf' },
        ];
        FontStore.registerFonts(...fonts);
      }
      const newReport = new PageReport({ language: 'jp' });
      const doc = await newReport.load(report).then(() => newReport.run());
      PdfExport.exportDocument(doc, {
        info: {
          title: 'N_Juc040_JuchuListOut',
        },
      })
        .then((result) => {
          result.download('N_Juc040_JuchuListOut_PDF');
        })
        .catch(console.error);
    },
    getData() {
      const params = {
        temSeq: true,
        temData: 'attachedData',
        temDate: '202210251800',
      };

      axios({
        url: '/front_sample/get_file_pdf',
        params,
        method: 'GET',
      })
        .then((res) => {
          const { temData, temDate } = res.data.responseData;
          this.attachedData = temData;
          this.attachmentTime = temDate.toString();
        })
        .catch((error: any) => {
          console.log(error);
        });
    },
  },
  created() {
    this.getData();
  },
});
